import { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { SampleTable, Loading, Popup } from "components"
import { samples, message } from "state_management"
import useT from "utils/hooks/useT"
import Table from "react-bootstrap/Table"
import { Button } from "react-bootstrap"
import { Graph } from "./TopologicalSort"

export default function SampleTableForUnplannedAnalysis({ analysisId }) {
  const dispatch = useDispatch()
  const { t } = useT("messages")
  const { t: tc } = useT("common")
  const sampleData = useSelector((state) => state.samples[analysisId] || null)
  const competenceGroups = useSelector((state) => state.competenceGroups)
  const assets = useSelector((state) => state.asset.assets)
  const hasExclusiveSample = sampleData?.items ? sampleData.items.some(sample => sample.exclusive === true) : false

  if (!sampleData) {
    dispatch(samples.fetchForUnplanned(analysisId))
  }

  const sampleCount = useSelector((state) => state.analyses.unplannedAnalyses[analysisId].sampleCount)

  useEffect(() => {
    if(sampleData && sampleData.items && sampleCount !== sampleData.items.length) {
      dispatch(message.warning(t("adhoc.analysisUpdatedRefresh")))
    }
  })


  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false)

  // Find the competence group members for the analysis
  const analysisName = useSelector((state) => state.analyses.unplannedAnalyses[analysisId].name)
  const analysis = Object.values(useSelector((state) => state.analysisDefinitions)).find(
    (analysis) => analysis.name === analysisName
  )

  // Ugly fix, first checking for '!planned' because 'analysis' is undefined for planned analyses.
  const tasks = analysis ? analysis.taskDefinitions : []

  // For sorting: Connections only exist if there are more than one task
  const connections = analysis ? analysis.taskDefinitionConnections : []

  // Driver Code for the topological sorting
  var g = new Graph(tasks.length)
  const tasksSorted = g.getSortedArray(g, connections, tasks)

  if (!sampleData || sampleData.isLoading) {
    return <Loading />
  }

  return (
    <>
      {showAdditionalInfo && (
        <Popup onCancel={() => setShowAdditionalInfo(false)} className="sampletable-additional-info-popup">
          <Table bordered hover className="SampleTable">
            <thead>
              <tr>
                <th>{tc("tasks")}</th>
                <th>{tc("competenceGroups")}</th>
                <th>{tc("allowedInstruments")}</th>
              </tr>
            </thead>
            <tbody>
              {tasksSorted.map((task) => (
                <tr key={task.id}>
                  <td>{task.name}</td>
                  <td>
                    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                      {task.allowedGroupIds
                        .map((ids) => competenceGroups[ids])
                        .map((group) => (
                          <li
                            style={{
                              whiteSpace: 'nowrap',        // Prevent text from wrapping to the next line
                              overflow: 'hidden',          // Hide any overflowing text
                              textOverflow: 'ellipsis',     // Display ellipsis (...) for overflowed text
                              maxWidth: '400px',            // Set a maximum width (adjust as needed)
                            }}
                            key={group.name}>{group.name}
                          </li>
                        ))}
                    </ul>
                  </td>
                  <td>
                    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                      {task.assetRequirements
                        .flatMap((requirement) => requirement.allowedAssetIds)
                        .map((id) => assets[id])
                        .map((asset) => (
                          <li
                            key={asset.name}
                            style={{
                              whiteSpace: 'nowrap',        // Prevent text from wrapping to the next line
                              overflow: 'hidden',          // Hide any overflowing text
                              textOverflow: 'ellipsis',     // Display ellipsis (...) for overflowed text
                              maxWidth: '300px',            // Set a maximum width (adjust as needed)
                            }}
                            title={asset.name}              // Optional: Show full name on hover
                          >
                            {asset.name}
                          </li>
                        ))}
                    </ul>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Popup>
      )}
      <div className="sample-additional-information-button">
        <Button variant="success" onClick={() => setShowAdditionalInfo(true)}>
          {tc("additionalInformation")}
        </Button>
      </div>
      <SampleTable popupSamples={sampleData.items} />
      {hasExclusiveSample && (
        <div className="explanation-text">
          {tc("exclusiveSampleIndicator")}
        </div>
      )}
    </>
  )
}
